<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-22 23:52:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/milkplan/components/AddressDet/index.vue
-->
<template>
  <!-- 订单详情地址信息 -->
  <div class="address_con border_top1px">
    <div class="text_left add_top">
      <img
        src="@/assets/order/icon_location@2x.png"
        alt=""
        class="icon_loaction"
      />
      <span class="font12 font_weight500 colo087 line_height_12 add_name"
        >{{ address.name }} {{ address.phone }}</span
      >
    </div>
    <div class="font12 font_weight400 colo055 line_height_17 text_left add_add">
      {{ address.province }} {{ address.city }} {{ address.district }}
      {{ address.addressLine }}
    </div>
    <div v-if="!finished" class="logist">
      <div class="text_left">
        <img
          src="@/assets/order/icon_send@2x.png"
          alt=""
          class="icon_loaction"
        />
        <span class="font12 font_weight500 colo087 line_height_16 add_name"
          >预计发货时间</span
        >
      </div>
      <div v-if="showAt" class="font12 font_weight500 colo087">
        {{ planDeliveredAt }}
      </div>
    </div>
    <div v-if="finished" class="logist">
      <div class="text_left">
        <img
          src="@/assets/order/icon_send@2x.png"
          alt=""
          class="icon_loaction"
        />
        <span class="font12 font_weight500 colo087 line_height_16 add_name"
          >送达时间</span
        >
      </div>
      <div class="font12 font_weight500 colo087">
        {{ deliveredAt }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    address: {
      type: Object,
      default() {
        return {};
      }
    },
    planDeliveredAt: {
      type: String,
      default: ""
    },
    deliveredAt: {
      type: String,
      default: ""
    },
    showAt: {
      type: Boolean,
      default: true
    },
    finished: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.address_con {
  position: relative;
  padding: 0 12px;
  .add_top {
    font-size: 0;
    padding-top: 12px;
  }
  .add_name {
    display: inline-block;
    vertical-align: middle;
  }
  .icon_loaction {
    width: 16px;
    vertical-align: middle;
    margin-right: 12px;
  }
  .add_add {
    padding: 8px 12px 0 28px;
  }
  .logist {
    font-size: 0;
    padding: 24px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
